// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';


import {
  shiftApi,
  routeApi,
  contractVehicleOrderApi,
  userApi } from
'./../lib/api';

import { ownerTypes } from '../lib/enum';
import { isDispatcher } from '../lib/helpers';

export const UPDATE_SHIFT = 'vehicles/shift/update';
export const FETCH_SHIFT = 'vehicles/shift/fetch';
export const CLEAN_SHIFT = 'vehicles/shift/clean';



const initialState: any = null;

/**
 * Устанавливаем диспетчера по умолчанию,
 * если он не выбран, ставить по дефолту того кто
 * запрашивает наряд
 */
const setDefaultDispatcher = async (shift) => {
  const canEdit = moment.utc(shift.date).isSameOrAfter(moment().startOf('day')); // если дата просрочена не можем менять
  if (canEdit && shift.dispatcherId === null) {
    const { employeeId, employee } = await userApi.fetchProfile();
    if (isDispatcher(employee)) {
      shift = {
        ...shift,
        dispatcherId: employeeId,
        dispatcher: employee
      };
      return await shiftApi.updateShift(shift);
    }
  }
  return shift;
};

const updateShiftAction = createAction<any>(UPDATE_SHIFT);
const fetchShiftAction = createAction<any>(FETCH_SHIFT);
const cleanShiftAction = createAction(CLEAN_SHIFT);

const shiftSlice = createSlice({
  name: 'shift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(fetchShiftAction, (state, { payload }) => ({ ...payload })).
    addCase(cleanShiftAction, () => null);
  }
});

export const shiftActions = {
  update: updateShiftAction,
  fetch: fetchShiftAction,
  clean: cleanShiftAction
};

export const updateShift = (shift) => async (
dispatch,
getState) =>
{
  // TODO: Решить в ПР что делать с этой ф-й
  await shiftApi.updateShift(shift);
};

export const updateShiftTrip = (updateTrip) => (
dispatch,
getState) =>
{
  const shift = getState().shift;
  if (shift) {
    const hasTrip = shift.trips.some((trip) => trip.id === updateTrip.id);
    const trips = hasTrip
      ? shift.trips.map((trip) =>
        trip.id === updateTrip.id ? updateTrip : trip
      )
      : [...shift.trips, updateTrip];

    dispatch(
      shiftActions.update({
        ...shift,
        trips
      })
    );
  }
};

export const fetchShift = (id) => async (
dispatch) =>
{
  let shift = await shiftApi.fetchShift(id);
  shift = await setDefaultDispatcher(shift);
  const trips = shift.trips.
  filter((trip) => trip.vehicle && trip.vehicle.ownerType === ownerTypes.self).
  map(async (trip) => {
    const newTrip = {
      ...trip
    };
    if (trip.expectedRouteId) {
      newTrip.expectedRoute = await routeApi.fetchRoute(trip.expectedRouteId);
    }
    if (trip.actualRouteId) {
      newTrip.actualRoute = await routeApi.fetchRoute(trip.actualRouteId);
    }
    return newTrip;
  });
  shift.trips = await Promise.all(trips);
  const orders = shift.orders.map(async (order) => {
    const newOrder = {
      ...order
    };
    const contractVehicleOrderId = parseInt(order.contractVehicleOrderId, 10);
    if (contractVehicleOrderId > 0) {
      newOrder.contractVehicleOrder = await contractVehicleOrderApi.fetchContractVehicleOrder(
        contractVehicleOrderId
      );
    }
    const routeId = parseInt(order.routeId, 10);
    if (routeId > 0) {
      newOrder.route = await routeApi.fetchRoute(routeId);
    }
    return newOrder;
  });
  shift.orders = await Promise.all(orders);
  dispatch(
    shiftActions.fetch({
      ...shift
    })
  );
};

export const cleanShift = () => async (
dispatch) =>
{
  dispatch(shiftActions.clean());
};

export default shiftSlice.reducer;
